import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { Media, MediaPurpose } from '@/models/media.model';
import { TranslationState } from '@/models/translation.model';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InitiativeState',
  props: {
  translation: {
    type: Object as PropType<TranslationState>,
  },
  media: {
    type: Array as PropType<Media[]>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "mt-16" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.state')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          (__props.translation && !__props.translation.title)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 0,
                variant: "text",
                icon: "mdi-alert",
                class: "mt-2",
                density: "compact",
                color: "warning"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.title_translation')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.translation && !__props.translation.quizTitle)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 1,
                variant: "text",
                icon: "mdi-alert",
                class: "mt-2",
                density: "compact",
                color: "warning"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.quiztitle_translation')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.translation && !__props.translation.shortDescription)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 2,
                variant: "text",
                icon: "mdi-alert",
                class: "mt-2",
                density: "compact",
                color: "warning"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.shortDescription_translation')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.translation && !__props.translation.description)
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 3,
                variant: "text",
                icon: "mdi-alert",
                class: "mt-2",
                density: "compact",
                color: "warning"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.description_translation')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.media && !__props.media.find((m) => m.purpose === _unref(MediaPurpose).Main))
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 4,
                variant: "text",
                icon: "mdi-alert",
                class: "mt-2",
                density: "compact",
                color: "warning"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.media_main')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
          __props.media &&
          !__props.media.find((m) => m.purpose === _unref(MediaPurpose).BackgroundImage)
        )
            ? (_openBlock(), _createBlock(_component_v_alert, {
                key: 5,
                variant: "text",
                icon: "mdi-alert",
                class: "mt-2",
                density: "compact",
                color: "warning"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.media_background')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.media, (m) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: m.id
            }, [
              (!m.translated?.description)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    variant: "text",
                    icon: "mdi-alert",
                    class: "mt-2",
                    density: "compact",
                    color: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.media_translation')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})